import Onedeck from 'onedeck'
import Loader from 'Loader/module'
import { LocalStorage } from 'quasar'
import { ROLE_GUEST } from 'Constants/roles'

/**
 * @module Root
 */
export default class Root extends Onedeck.RootModule {
  init() {
    this.Loader = new Loader()

    /**
     * Если роли еще нет - присвоить роль гостя
     * */

    let userRole = LocalStorage.getItem('userRole')
    if (!userRole) {
      LocalStorage.set('userRole', ROLE_GUEST)
      userRole = ROLE_GUEST
    }

    /**
     * Чтобы не сломалось у тех у кого уже есть токен,
     * то удаляем токен если роль - гость
     * */
    const token = LocalStorage.getItem('authentication_token')
    if (userRole === 'guest' && token) {
      LocalStorage.remove('authentication_token')

      this.$$rout({
        path: '/'
      })
    }

    this.eventHandler()
  }

  eventHandler() {
    this.$$on('loadingShow', () => {
      this.Loader.show()
    })

    this.$$on('loadingHide', () => {
      this.Loader.hide()
    })

    this.$$on('logout', () => {
      localStorage.removeItem('authentication_token')
      localStorage.removeItem('refresh_token')
      localStorage.removeItem('user')
    })
  }

  dispatcher(path) {
    this.checkAuth(path[0])
  }

  mounted() {
    setTimeout(() => this.Loader.hide(), 600)
  }

  /**
   * Проверка авторизации и аутентификации
  */
  checkAuth(page) {
    const userRole = LocalStorage.getItem('userRole') ?? ROLE_GUEST
    const currentModuleAccessRoles = this.$$config.modules[page]?.roles

    if (!LocalStorage.getItem('authentication_token')) {
      /**
       * Если пользовател не авторизован(гость), и пытается зайти на недоступную страницу,
       * то отправить его на авторизацию
       * */

      if (!currentModuleAccessRoles.includes('guest')) {
        this.$$rout({
          path: '/auth'
        })
      }
    } else if (!currentModuleAccessRoles.includes(userRole)) {
      /**
       * Если авторизован, но доступа к модулю все равно нет - отправить на 404
       * */

      this.$$rout({
        path: '/404'
      })
    }
  }
}
